export const hotKeyWords = [
  {
    url: 'http://souke1.xdf.cn/Search.aspx?cid=0&ccc=11&gc=0&v=5&attr=148&adpl=XDF_yingyuN_hotword_1&adct=成人新概念',
    title: '成人新概念'
  },
  {
    url: 'http://souke1.xdf.cn/Search.aspx?cid=0&ccc=11&gc=0&v=5&attr=146&adpl=XDF_yingyuN_hotword_2&adct=初中新概念',
    title: '初中新概念'
  },
  {
    url: 'http://souke1.xdf.cn/Search.aspx?cid=1&ccc=11&attr=986 &adpl=XDF_yingyuN_hotword_3&adct=高中新概念',
    title: '高中新概念'
  },
  {
    url: 'http://souke1.xdf.cn/Search.aspx?cid=0&ccc=46&attr=199&gc=0&v=5&adpl=XDF_yingyuN_hotword_4&adct=词汇速记精讲',
    title: '词汇速记精讲'
  },
  {
    url: 'http://souke1.xdf.cn/Search.aspx?cid=0&ccc=406&gc=0&v=5&adpl=XDF_yingyuN_hotword_5&adct=倍学口语',
    title: '倍学口语'
  },
  {
    url: 'http://souke1.xdf.cn/Search.aspx?cid=0&ccc=16&adpl=XDF_yingyuN_hotword_6&adct=听说速成',
    title: '听说速成'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/english/hotkeywords.js